exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2645790472/src/~/core-js/library/modules/_object-gops.js
// module id = E5ub
// module chunks = 6